// ======================= Imports =======================
import React, { useEffect, useRef, useState } from "react";
import "./css/InventoryList.css";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { api } from "../../../../../../../utility/AxiosInceptor";
import { Dialog } from "primereact/dialog";
import AddInventoryAgainstBillingModel from "./AddInventory/AddInventory";
import { Toast } from "primereact/toast";
import { CancelPopup, PlanEditIcon } from "../../../../../../../utility";
import { OverlayPanel } from "primereact/overlaypanel";
import CommonLoaderBlue from "../../../../Prepaid_Updated/Add_Service/components/PaymentScreen/dialog/loader/LoaderBlue";

// ======================= Main Component =======================
export default function InventoryList({
  refreshInventoryList,
  setRefreshInventoryList,
  data,
  billingModelSelect,
  inventorySelect,
  setUpdateInventory,
  inventorySelected,
  setBillingModelFromList,
  setInventorySelected,
  setRefresh,
  refresh,
}) {
  // ======================= State Management =======================
  const [loader, setLoader] = useState(true);
  let toast = useRef();
  const [inventoryStatusLoader, setInvetoryStatusLoader] = useState(false);
  const [addInventory, setAddInventory] = useState(false);
  const [isActiveSelected, setIsActiveSelected] = useState(false);
  const [isDeActiveSelected, setIsDeActiveSelected] = useState(false);
  let parseLoginRes = JSON.parse(localStorage.getItem("userData"));
  const [InventoryList, setinventoryList] = useState([]);
  const [selectedInventory, setSelectedInventory] = useState([]);
  const [rowData, setRowData] = useState([]);
  const op = useRef(null);

  // ======================= Update Inventory Status =======================
  const updateBillingModelStatus = () => {
    op.current.hide();
    setLoader(true);
    setinventoryList([]);
    api
      .put(
        `/api/inventoryType/statusUpdate?inventoryTypeId=${inventorySelected._id}&active=${inventorySelected?.active ? false : true}`
      )
      .then((res) => {
        toast.current.show({
          severity: "success",
          summary: "Inventory Type Status Updation",
          detail: `Inventory Type ${inventorySelected?.active ? "Deactivated" : "Activated"} Successfully`,
        });

        setTimeout(() => {
          setRefreshInventoryList((prev) => !prev);

          if (op.current) {
            op.current.hide();
          }
        }, 500);
      })
      .catch((err) => {
        setLoader(false);
        toast.current.show({
          severity: "error",
          summary: "Inventory Type Status Updation",
          detail: `Inventory Type ${inventorySelected?.active ? "Deactivation" : "Activation"} Failed`,
        });

        if (op.current) {
          op.current.hide();
        }
      });
  };

  // ======================= Fetch Inventory List =======================
  const billingModelId = data?._id;
  useEffect(() => {
    setLoader(true);
    setinventoryList([]);
    api
      .get(`/api/inventoryType/all`, {
        params: {
          serviceProvider: parseLoginRes?.company,
          billingModel: billingModelId,
        },
      })
      .then((res) => {
        setLoader(false);
        setinventoryList(res?.data?.data);
      })
      .catch((err) => {
        setLoader(false);
      });
  }, [
    inventorySelect,
    refreshInventoryList,
    billingModelId,
    parseLoginRes.company,
  ]);

  // ======================= Bulk Activate =======================
  const handleActive = () => {
    setInvetoryStatusLoader(true);
    setIsActiveSelected(true);
    const inventoryTypeIds = selectedInventory.map((user) => user._id);
    const dataToSend = {
      inventoryTypeIds,
      active: true,
    };

    api
      .put(`/api/inventoryType/statusUpdateMultiple`, dataToSend)
      .then((res) => {
        toast.current.show({
          severity: "success",
          summary: "Inventory Status",
          detail: res?.data?.msg || "Inventories Activated Successfully.",
        });

        setSelectedInventory([]);
        setRefreshInventoryList((prev) => !prev);
        setInvetoryStatusLoader(false);
        setIsActiveSelected(false);
      })
      .catch((err) => {
        setIsActiveSelected(false);
        setInvetoryStatusLoader(false);

        toast.current.show({
          severity: "error",
          summary: "Inventory Status",
          detail: err?.response?.data?.msg || "Inventories Activation Failed.",
        });
      });
  };

  // ======================= Bulk Deactivate =======================
  const handleDeactive = () => {
    setInvetoryStatusLoader(true);
    setIsDeActiveSelected(true);

    const inventoryTypeIds = selectedInventory.map((user) => user._id);

    const dataToSend = {
      inventoryTypeIds,
      active: false,
    };

    api
      .put(`/api/inventoryType/statusUpdateMultiple`, dataToSend)
      .then((res) => {
        setIsDeActiveSelected(false);
        toast.current.show({
          severity: "success",
          summary: "Inventory Status",
          detail: res?.data?.msg || "Inventories Deactivated Successfully.",
        });
        setSelectedInventory([]);
        setRefresh((prev) => !prev);
        setInvetoryStatusLoader(false);
      })
      .catch((err) => {
        setIsDeActiveSelected(false);
        toast.current.show({
          severity: "error",
          summary: "Inventory Status",
          detail:
            err?.response?.data?.msg || "Invenotories Deactivation Failed",
        });
        setInvetoryStatusLoader(false);
      });
  };

  // ======================= Render =======================
  return (
    <div>
      <Toast ref={toast} />
      <div className="inventorylisttable">
        {/* ======================= Selected Inventory Actions ======================= */}
        {selectedInventory?.length > 0 && (
          <div className="flex flex-column justify-content-start align-items-center selecteddatapopup">
            <div className="flex w-full justify-content-end">
              <span
                onClick={() => {
                  if (!inventoryStatusLoader) {
                    setSelectedInventory([]);
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <CancelPopup />
              </span>
            </div>
            <div className="flex justify-content-start w-full align-items-center selectedrowdata ">
              <div
                className="flex showselectedroles"
                style={{ width: "12rem", marginLeft: "2.4rem" }}
              >
                <p>
                  Selected: <span>{selectedInventory?.length}</span>
                </p>
              </div>
              <div
                className="flex"
                style={{
                  width: "25.6rem",
                  marginLeft: "8.8rem",
                  gap: "1.2rem",
                }}
              >
                <Button
                  loading={isDeActiveSelected}
                  disabled={inventoryStatusLoader}
                  onClick={handleDeactive}
                  className="addnewrolebtn"
                  label="Deactive"
                  style={{ width: "12rem" }}
                />
                <Button
                  loading={isActiveSelected}
                  disabled={inventoryStatusLoader}
                  onClick={handleActive}
                  className="adduserbtn"
                  label="Active"
                  style={{ width: "12rem" }}
                />
              </div>
            </div>
          </div>
        )}
        {/* ======================= Inventory Data Table ======================= */}
        <DataTable
          value={InventoryList}
          size="small"
          emptyMessage={
            loader ? (
              <div
                style={{
                  position: "absolute",
                  marginTop: "-1.4rem",
                  width: "108.4rem",
                }}
                className="flex flex-wrap justify-content-center align-items-center"
              >
                <CommonLoaderBlue color="royalblue" customSize={14} />
              </div>
            ) : (
              "No items in inventory"
            )
          }
          selectionMode="checkbox"
          selection={selectedInventory}
          onSelectionChange={(e) => setSelectedInventory(e.value)}
          className="inventoryListtable"
          stripedRows
          style={{ marginTop: "2.4rem" }}
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "1rem" }}
          ></Column>
          <Column header="Inventory Type" field="inventoryType" />
          <Column header="Make" field="make" />
          <Column header="Model" field="model" />
          <Column header="Selling Price" field="sellingPrice" />
          <Column header="Discount" field="discount" />
          <Column header="Profit Margin" field="profitMargin" />
          <Column header="Identifier" field="identifierType.identifier" />
          <Column
            header="Status"
            field="active"
            body={(rowData) => (
              <label className={rowData?.active ? "active" : "deactive"}>
                {" "}
                {rowData?.active ? "Active" : "Deactive"}
              </label>
            )}
          />
          <Column
            header="Action"
            headerClassName="p-3"
            body={(rowData) => {
              return (
                <>
                  <div
                    onClick={(e) => {
                      setInventorySelected(rowData);
                      setRowData(rowData);
                      setBillingModelFromList(rowData?.billingModel?._id);
                      op.current.toggle(e);
                    }}
                    className="actionbtnmain flex justify-content-end"
                  >
                    <PlanEditIcon />
                  </div>
                </>
              );
            }}
            field="Edit"
          />
        </DataTable>
        {/* ======================= Overlay Panel for Actions ======================= */}
        <OverlayPanel
          ref={op}
          style={{ width: "10.9em", height: "11.2rem" }}
          className="flex align-items-center inventorylist"
        >
          <div className="flex flex-column w-full overlay">
            <div
              className={
                rowData?.active
                  ? "flex justify-content-start align-items-center prospectoverlay"
                  : "flex justify-content-start align-items-center prospectoverlayactive"
              }
              style={{ height: "3.2rem" }}
              onClick={() => {
                if (rowData?.active) {
                  updateBillingModelStatus();
                  op.current.hide();
                } else {
                }
              }}
            >
              <label
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  color: !rowData?.active ? "#2627CF" : "",
                }}
              >
                Deactive
              </label>
            </div>
            <div
              className={
                !rowData?.active
                  ? "flex justify-content-start align-items-center prospectoverlay"
                  : "flex justify-content-start align-items-center prospectoverlayactive"
              }
              style={{ height: "3.2rem" }}
              onClick={() => {
                if (!rowData?.active) {
                  updateBillingModelStatus();
                  op.current.hide();
                } else {
                }
              }}
            >
              <label
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  color: rowData?.active ? "#2627CF" : "",
                }}
              >
                Active
              </label>
            </div>
            <div
              className="flex justify-content-start align-items-center prospectoverlay"
              style={{ height: "3.2rem" }}
              onClick={() => {
                setUpdateInventory(true);
                if (op.current) {
                  op.current.hide();
                }
              }}
            >
              <label style={{ fontSize: "1.2rem", fontWeight: "500" }}>
                Edit
              </label>
            </div>
          </div>
        </OverlayPanel>
      </div>
      {/* ======================= Add Inventory Dialog ======================= */}
      <Dialog
        style={{ width: "85vw" }}
        header="Add Inventory"
        visible={addInventory}
        onHide={() => {
          setAddInventory(false);
          setRefresh((prev) => !prev);
        }}
      >
        <AddInventoryAgainstBillingModel
          setRefresh={setRefresh}
          setAddInventory={setAddInventory}
          billingModelSelect={billingModelSelect}
        />
      </Dialog>
    </div>
  );
}
